module.exports = __webpack_public_path__ + "img/Light Sleep01.58ad8bab.png";